import { Button } from "@components/shadcn-ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTrigger,
} from "@components/shadcn-ui/dialog";
import { Form } from "@components/shadcn-ui/form";
import { DynamicFormField } from "@components/ui/DynamicInput";
import { toast } from "@customHooks/useToast";
import { APPLICATION_DETAILS } from "features/loanApplications/formFieldsConfig/applicationDetails";
import PermissionWrapper from "features/Permission/PermissionWrapper";
import { Action } from "features/Permission/types";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

function ProductTypeModal({
  onChange,
  onSubmit,
}: {
  onChange?: Function;
  onSubmit?: Function;
}) {
  const [isModalOpen, setModalOpen] = useState(false);
  const form = useForm();
  // Watch the specific field for changes
  const selectedProductKey = form.watch(APPLICATION_DETAILS.fields[1].name);

  useEffect(() => {
    if (selectedProductKey) {
      onChange && onChange(selectedProductKey);
      // Add additional logic here, like triggering an API or state update
    }
  }, [selectedProductKey]);

  const handleSumbit = () => {
    if (!selectedProductKey) {
      toast({
        variant: "default",
        description: "Please select a product type.",
      });
      return;
    }
    onSubmit && onSubmit();
  };

  return (
    <>
      <Dialog open={isModalOpen} onOpenChange={setModalOpen}>
        <PermissionWrapper actions={Action.EDIT_APPLICATION}>
          <DialogTrigger asChild>
            <Button className="mt-5">Create new application</Button>
          </DialogTrigger>
        </PermissionWrapper>
        <DialogContent>
          <DialogHeader className="mt-8 w-[80%] mx-auto">
            <h2>Please select a product type to create a new application.</h2>
          </DialogHeader>
          <div className="mt-4 px-8">
            <Form {...form}>
              <DynamicFormField
                field={APPLICATION_DETAILS.fields[1]}
                isDisabled={false}
              />
            </Form>
          </div>
          <DialogFooter className="flex gap-4 flex-row justify-center pb-4 mt-4">
            <Button disabled={!selectedProductKey} onClick={handleSumbit}>
              Initiate Application
            </Button>
            <Button variant="secondary" onClick={() => setModalOpen(false)}>
              Cancel
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default ProductTypeModal;
